export const SITE_ORIGIN = 'https://www.leadingng.com';

export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/assets/images/logo.png`;

const MAX_DESCRIPTION_LENGTH = 158;

function stripHtml(html: string): string {
  return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

export function truncateForMeta(text: string, max = MAX_DESCRIPTION_LENGTH): string {
  const normalized = text.replace(/\s+/g, ' ').trim();
  if (normalized.length <= max) return normalized;
  return `${normalized.slice(0, max - 1).trimEnd()}…`;
}

/** Strip tags and cap length for meta descriptions (e.g. technology intros). */
export function plainTextForMeta(htmlish: string): string {
  return truncateForMeta(stripHtml(htmlish));
}

export type PageMetaInput = {
  title: string;
  description: string;
  /** Path only, e.g. `/projects` or `/` */
  canonicalPath: string;
  keywords?: string;
  ogImage?: string;
};

export function setPageMeta(input: PageMetaInput): void {
  const description = truncateForMeta(input.description);
  const path = input.canonicalPath.startsWith('/')
    ? input.canonicalPath
    : `/${input.canonicalPath}`;
  const canonicalUrl = `${SITE_ORIGIN}${path === '/' ? '/' : path}`;
  const ogImage = input.ogImage ?? DEFAULT_OG_IMAGE;

  document.title = input.title;

  const setNamed = (name: string, content: string) => {
    let el = document.head.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', name);
      document.head.appendChild(el);
    }
    el.content = content;
  };

  const setProperty = (property: string, content: string) => {
    let el = document.head.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('property', property);
      document.head.appendChild(el);
    }
    el.content = content;
  };

  setNamed('description', description);
  if (input.keywords !== undefined) {
    setNamed('keywords', input.keywords);
  }

  setProperty('og:type', 'website');
  setProperty('og:title', input.title);
  setProperty('og:description', description);
  setProperty('og:url', canonicalUrl);
  setProperty('og:image', ogImage);
  setProperty('og:locale', 'en_NZ');

  setNamed('twitter:card', 'summary_large_image');
  setNamed('twitter:title', input.title);
  setNamed('twitter:description', description);
  setNamed('twitter:image', ogImage);

  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.href = canonicalUrl;
}
